"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelChangeBuffer = void 0;
var create = function () { return ({
    instances: {},
    parentLinks: {},
    childLinks: {},
    states: {},
}); };
var assignRecordDeltas = function (dest, source) {
    var e_1, _a;
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            dest[key] = source[key];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
// eslint-disable-next-line max-len
var assignBranchDeltas = function (dest, source) {
    var e_2, _a;
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (source[key] === null) {
                dest[key] = null;
            }
            else if (!dest[key]) {
                dest[key] = {};
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
var assign = function (dest, source) {
    var e_3, _a, e_4, _b;
    // instances:
    assignRecordDeltas(dest.instances, source.instances);
    // parentLinks:
    assignRecordDeltas(dest.parentLinks, source.parentLinks);
    // childLinks:
    assignBranchDeltas(dest.childLinks, source.childLinks);
    try {
        for (var _c = __values(Object.keys(source.childLinks)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var entityId = _d.value;
            if (source.childLinks[entityId]) {
                assignRecordDeltas(dest.childLinks[entityId], source.childLinks[entityId]);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_3) throw e_3.error; }
    }
    // states:
    assignBranchDeltas(dest.states, source.states);
    try {
        for (var _e = __values(Object.keys(source.states)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var entityId = _f.value;
            if (source.states[entityId]) {
                assignRecordDeltas(dest.states[entityId], source.states[entityId]);
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return dest;
};
var applyRecordDeltas = function (dest, source) {
    var e_5, _a;
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (source[key] === null) {
                delete dest[key];
            }
            else {
                dest[key] = source[key];
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_5) throw e_5.error; }
    }
};
var applyBranchDeltas = function (dest, source) {
    var e_6, _a;
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (source[key] === null) {
                delete dest[key];
            }
            else if (!dest[key]) {
                dest[key] = {};
            }
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_6) throw e_6.error; }
    }
};
var apply = function (snapshot, buffer) {
    // Applying record deltas involves comparing two records and for instances where the source contains a "null" entry we must "delete"
    // this from the destination record.  Any non-null entries in the source will be mirrored in the destination. This operation satisfies
    // most of the apply process, with the exception of structures (childLinks, states) that are records of records (trees), where we must
    // perform a branc delta first then the record delta for each remaining leaf of the tree.
    var e_7, _a, e_8, _b;
    // instances:
    applyRecordDeltas(snapshot.instances, buffer.instances);
    // parentLinks:
    applyRecordDeltas(snapshot.parentLinks, buffer.parentLinks);
    // childLinks:
    applyBranchDeltas(snapshot.childLinks, buffer.childLinks);
    try {
        for (var _c = __values(Object.keys(buffer.childLinks)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var entityId = _d.value;
            if (buffer.childLinks[entityId]) {
                applyRecordDeltas(snapshot.childLinks[entityId], buffer.childLinks[entityId]);
            }
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_7) throw e_7.error; }
    }
    // states:
    applyBranchDeltas(snapshot.states, buffer.states);
    try {
        for (var _e = __values(Object.keys(buffer.states)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var entityId = _f.value;
            if (buffer.states[entityId]) {
                applyRecordDeltas(snapshot.states[entityId], buffer.states[entityId]);
            }
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_8) throw e_8.error; }
    }
};
exports.ModelChangeBuffer = { create: create, assign: assign, apply: apply };
